// import { isEmpty } from 'lodash';
import { FC } from 'react';
import Link from 'next/link';
import styles from './Next.module.scss';

interface INext {
  currentPageNo?: number;
  pagesCount?: number;
  postName?: string;
}

const Next: FC<INext> = ({ currentPageNo, pagesCount, postName }) => {
  if (
    !currentPageNo ||
    !pagesCount
    // || isEmpty( postName )
  ) {
    return null;
  }

  // If you are on the last page, don't show next link.
  if (pagesCount < currentPageNo + 1) {
    return null;
  }

  const paginationLink = `/${postName}${currentPageNo + 1}`;

  return (
    <Link prefetch={false} className={styles.next} href={paginationLink}>
      Следующая
    </Link>
  );
};

export default Next;
